import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import SettingsCollection, { ArchiveRestoreMutationTuple } from '../../generic/SettingsCollection';

export default function JobLevelsListContainer() {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsCollection
			query={graphql.useJobLevelsQuery}
			lazyQuery={graphql.useJobLevelsLazyQuery}
			field="jobLevels"
			translationKey="settings.jobLevels"
			title={(level: graphql.JobLevel) => localize(level.title).text}
			link={(level) => `/settings/jobs/levels/${level.id}`}
			variables={{}}
			archive={graphql.useArchiveJobLevelMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreJobLevelMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/jobs/levels/new')}
		/>
	);
}
